
import { Flex, Spinner } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import UsersTable from "../UsersTablePage/UsersTable";
import PromotoraRegisterForm from "../RegisterPromotoraForm";
import CorbansTable from "../CorbansTable";
import { useParams } from "react-router-dom";
import { getCreditPromoterById } from "@/services/creditPromoter.service";

export default function CreditPromoterDetails() {
  const id = useParams().id;
  const { data: creditPromoter, isLoading } = useQuery({
    queryKey: ["creditPromoter", id],
    queryFn: () => getCreditPromoterById(id!),
    enabled: !!id && id !== "new",
  });


  if (isLoading) {
    return (
      <Flex justify="center" align="center" height="200px" width="100%">
        <Spinner
          size="xl"
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
        />
      </Flex>
    );
  }

  return (
    <Flex direction="column" width="100%" gap="2rem">
      <PromotoraRegisterForm />
      {(id && id !== 'new' && (
        <>
          <UsersTable creditPromoter={creditPromoter ?? undefined} isRegisterFromPromoter={true} />
          <CorbansTable creditPromoterId={id} />
        </>
      ))}
    </Flex>
  );
}


